import { defaultRequestMeta, RequestActionType } from "./constants";
import { RequestActionMeta, RequestActionPayload } from "./types";

export const inProgress = (meta?: RequestActionMeta) => ({
  type: RequestActionType.InProgress,
  meta: { ...defaultRequestMeta, ...(meta ?? {}) },
});

export const success = <T>(
  { data }: RequestActionPayload<T>,
  meta?: RequestActionMeta,
) => ({
  type: RequestActionType.Success,
  payload: { data },
  meta: { ...defaultRequestMeta, ...(meta ?? {}) },
});

export const error = <T>(
  { error }: RequestActionPayload<T>,
  meta?: RequestActionMeta,
) => ({
  type: RequestActionType.Error,
  payload: { error },
  meta: { ...defaultRequestMeta, ...(meta ?? {}) },
});

export const reset = <T>(payload?: RequestActionPayload<T>) => ({
  type: RequestActionType.Reset,
  payload,
});
